(() => {
  const cardGetCareSearch = () => {

    const cards = document.querySelectorAll('.card--get-care-search');

    cards.forEach((card) => {
      const zipcodeField = card.querySelector('.card--get-care-search__input input');
      const searchButton = card.querySelector('.card--get-care-search__button input');

      const specialty = searchButton.getAttribute('data-specialty');
      const searchType = searchButton.getAttribute('data-search-type');

      const search = () => {
        let url = ` / find - a - ${searchType} ? term = ${specialty.replace(' ', '+')}`;

        // We don't always include a zipcode field.
        if (zipcodeField !== null) {
          const zipcode = zipcodeField.value;

          url = `${url} & zip = ${zipcode}`;
        }

        window.location = url;
      };

      // The keyboard seems to also trigger this `click` event.
      searchButton.addEventListener('click', search);

      // Search on `Enter` within the zipcode input field.
      if (zipcodeField !== null) {
        zipcodeField.addEventListener('keyup', (event) => {
          if (event.key === 'Enter') {
            search();
          }
        })
      }
    });
  };

  if (document.readyState !== 'loading'){
    cardGetCareSearch();
  }
  else {
    document.addEventListener('DOMContentLoaded', cardGetCareSearch);
  }
})();
